import React, { useContext, useEffect } from "react";
import {
    Control,
    FieldErrors,
    UseFormSetValue,
} from "react-hook-form";
import { Typography, Switch, Grid } from "@mui/material"
import TextInput from "../../../main/components/TextInput";
import { UsinasContext } from "../context/UsinasContextProvider";
export function SubstacaoComponentForm(props: {
    setValue: UseFormSetValue<any>;
    control: Control<any, any>;
    errors: FieldErrors<any>;
}): React.ReactNode {
    const { control, errors, setValue } = props;
    const { newUsina } = useContext(UsinasContext);

    const [hasTransformer, setHasTransformer] = React.useState(true);

    useEffect(() => {
        setValue("substation.hasTransformer", hasTransformer);
    }, [hasTransformer]);

    useEffect(() => {
        setHasTransformer(newUsina?.substation?.hasTransformer ?? false);
    }, [newUsina]);

    const [hasSubstation, setHasSubstation] = React.useState(true);

    useEffect(() => {
        setValue("substation.hasSubstation", hasSubstation);
    }, [hasSubstation]);

    useEffect(() => {
        setHasSubstation(newUsina?.substation?.hasSubstation ?? false);
    }, [newUsina]);

    return (
        <>
            <Grid item xs={12} textAlign={"start"}>
                <Typography
                    variant="h6"
                    sx={{
                        borderBottom: "1px solid #ccc",
                        paddingBottom: 1,
                        marginBottom: "15px",
                        marginTop: "30px",
                    }}
                >
                    Subestação
                </Typography>
            </Grid>

            <Grid item xs={12} md={2} display={"flex"} sx={{ justifyContent: "center" }}>
                <Grid>
                    <Typography variant="subtitle1" sx={{ marginTop: "15px" }}>
                        A Usina possui Subestação?
                    </Typography>
                    Não
                    <Switch
                        checked={hasSubstation}
                        onChange={(_, checked) => {
                            setHasSubstation(checked);
                        }}
                    />
                    Sim
                </Grid>
            </Grid>

            <Grid display={"flex"} item xs={12} md={3} sx={{ justifyContent: "center" }}>
                <TextInput
                    control={control}
                    fieldName={`substation.disjuntorTag`}
                    label="Tag do disjuntor"
                    errors={errors}
                    disabled={!hasSubstation}
                    sx={{ width: "100%", maxWidth: "280px" }}
                />
            </Grid>

            <Grid item xs={12} md={3} display={"flex"} sx={{ justifyContent: "center" }}>
                <Grid>
                    <Typography variant="subtitle1" sx={{ marginTop: "15px" }}>
                        A Subestação possui transformador?
                    </Typography>
                    Não
                    <Switch
                        checked={hasTransformer}
                        disabled={!hasSubstation}
                        onChange={(_, checked) => {
                            setHasTransformer(checked);
                        }}
                    />
                    Sim
                </Grid>
            </Grid>
        </>
    );
}
